module.exports = __webpack_public_path__ + "img/welcome_5.71181797.jpg";